import SingleSelect from './singleSelect.vue';
import MultiSelect from './multiSelect.vue';
import Place from './place.vue';
import Range from './range.vue';

export default {
    name: 'SearchPanel',
    template: '#realty-search-search-panel',
    components: { SingleSelect, MultiSelect, Place, Range },
    props: {
        totalResults: {
            type: Number,
            required: false,
            default: 0,
        },
        totalAlternatives: {
            type: Number,
            required: false,
            default: 0,
        },
        prime: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            kind: CONFIG.misc.params.kind,
            category: CONFIG.misc.params.category,
            place: CONFIG.misc.params.pids,
            type: CONFIG.misc.params.type,

            orderBy: CONFIG.misc.params.order_by,
            resultsPerPage: String(CONFIG.misc.params.results_per_page),

            kindValues: [],
            categoryValues: [],

            filterFields: [],
            filterValues: {},

            metaFields: {},

            initialValues: {},

            panelCollapsed: true,

            altSearchPageLink: '',
        };
    },
    computed: {
        collapsingButtonText() {
            return this.panelCollapsed ? 'Mehr Optionen' : 'Weniger Optionen';
        },
        typeValues() {
            const searchFields = { ...CONFIG.misc.searchFields },
                typeValues = [];

            if (this.kind && 'objekttyp' in searchFields && this.kind in searchFields.objekttyp) {
                for (let key in searchFields.objekttyp[this.kind]) {
                    if (Object.prototype.hasOwnProperty.call(searchFields.objekttyp[this.kind], key)) {
                        typeValues.push(searchFields.objekttyp[this.kind][key]);
                    }
                }
            }

            return typeValues;
        },
        altSearchPageText() {
            return this.prime ? 'Alle anzeigen' : 'Nur Prime anzeigen';
        },
    },
    watch: {
        typeValues() {
            this.type = ''; // clear the value if the values change
        },
    },
    mounted() {
        const searchFields = { ...CONFIG.misc.searchFields },
            filterFields = [...CONFIG.misc.filterFields],
            kindValues = [],
            categoryValues = [],
            filterModel = {},
            metaModel = {};

        this.altSearchPageLink = CONFIG.misc.searchPageAlt;

        if (!searchFields) {
            return;
        }

        for (let key in searchFields.objektart) {
            if (Object.prototype.hasOwnProperty.call(searchFields.objektart, key)) {
                kindValues.push(searchFields.objektart[key]);
            }
        }

        for (let key in searchFields.vermarktungsart) {
            if (Object.prototype.hasOwnProperty.call(searchFields.vermarktungsart, key)) {
                categoryValues.push(searchFields.vermarktungsart[key]);
            }
        }

        this.kindValues = kindValues;
        this.categoryValues = categoryValues;
        this.metaFields = { ...CONFIG.misc.metaFields };

        filterFields.forEach((field) => {
            filterModel[field.name] = field.value;
        });

        this.filterValues = filterModel;
        this.filterFields = filterFields;

        this.initialValues = {
            ...filterModel,
            ...metaModel,
        };
    },
    methods: {
        addUrlParam(url, param, value) {
            const isArray = Array.isArray(value);

            let deleteParam = true;

            if (isArray) {
                if (value.length) {
                    deleteParam = false;
                    value.forEach((v, i) => {
                        if (i === 0) {
                            url.searchParams.set(`${param}[]`, v);
                        } else {
                            url.searchParams.append(`${param}[]`, v);
                        }
                    });
                }
            } else if (typeof value === 'object') {
                /* eslint-disable eqeqeq */
                if (
                    Object.prototype.hasOwnProperty.call(this.initialValues, param) &&
                    (value.min != this.initialValues[param].min || value.max != this.initialValues[param].max)
                ) {
                    deleteParam = false;
                    url.searchParams.set(`${param}[min]`, value.min);
                    url.searchParams.set(`${param}[max]`, value.max);
                }
                /* eslint-enable eqeqeq */
            } else if (value) {
                deleteParam = false;
                url.searchParams.set(param, value);
            }

            if (deleteParam) {
                url.searchParams.delete(param + (isArray ? '[]' : ''));
            }
        },
        showResults() {
            this.$nextTick(() => {
                const url = new URL(location.href);

                this.addUrlParam(url, 'kind', this.kind);
                this.addUrlParam(url, 'category', this.category);
                this.addUrlParam(url, 'pids', this.place);
                this.addUrlParam(url, 'type', this.type);
                this.addUrlParam(url, 'pg', 1);

                for (let param in this.filterValues) {
                    if (Object.prototype.hasOwnProperty.call(this.filterValues, param)) {
                        this.addUrlParam(url, param, this.filterValues[param]);
                    }
                }

                this.addUrlParam(url, 'order_by', this.orderBy);
                this.addUrlParam(url, 'results_per_page', this.resultsPerPage);

                location.href = decodeURI(url.href);
            });
        },
    },
};
